var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.roles.some(x=> x.id ===2))?_c('v-chip',{staticClass:"ml-2",attrs:{"x-small":""}},[_vm._v("Admin")]):_vm._e(),(_vm.roles.some(x=> x.id ===3))?_c('v-chip',{staticClass:"ml-2",attrs:{"x-small":""}},[_vm._v("HR")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }